<!-- Answers: bookings per ISO weekday this week vs same weekdays last year. -->
<template>
    <dashboard-panel :title="title" :subtitle="subtitle">
        <dashboard-bar-chart-host
            :labels="weekdayLabels"
            :datasets="datasets"
            :extra-options="chartOptions"
        />
    </dashboard-panel>
</template>

<script setup>
import { computed } from "vue";
import { sumSeries } from "../../helpers/dashboardAggregations";
import DashboardBarChartHost from "./DashboardBarChartHost.vue";
import DashboardPanel from "./DashboardPanel.vue";

const props = defineProps({
    weekdayLabels: { type: Array, default: () => [] },
    datasets: { type: Array, default: () => [] },
});

const title = "This week bookings per day (with total)";
// Subtitle from chart series so it cannot desync from the bars (stale KPI / race).
const subtitle = computed(() => {
    const total = sumSeries(props.datasets?.[0]?.data);
    return `Total: ${total} bookings`;
});
const chartOptions = { plugins: { legend: { display: true } } };
</script>
